"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createAvatarStyle;
function createAvatarStyle(_ref) {
  var avatarBorderRadius = _ref.avatarBorderRadius,
    avatarSize = _ref.avatarSize;
  return {
    '&.webchat__defaultAvatar': {
      borderRadius: avatarBorderRadius,
      height: avatarSize,
      width: avatarSize
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVBdmF0YXJTdHlsZSIsIl9yZWYiLCJhdmF0YXJCb3JkZXJSYWRpdXMiLCJhdmF0YXJTaXplIiwiYm9yZGVyUmFkaXVzIiwiaGVpZ2h0Iiwid2lkdGgiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TdHlsZXMvU3R5bGVTZXQvQXZhdGFyLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFN0cmljdFN0eWxlT3B0aW9ucyB9IGZyb20gJ2JvdGZyYW1ld29yay13ZWJjaGF0LWFwaSc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGNyZWF0ZUF2YXRhclN0eWxlKHsgYXZhdGFyQm9yZGVyUmFkaXVzLCBhdmF0YXJTaXplIH06IFN0cmljdFN0eWxlT3B0aW9ucykge1xuICByZXR1cm4ge1xuICAgICcmLndlYmNoYXRfX2RlZmF1bHRBdmF0YXInOiB7XG4gICAgICBib3JkZXJSYWRpdXM6IGF2YXRhckJvcmRlclJhZGl1cyxcbiAgICAgIGhlaWdodDogYXZhdGFyU2l6ZSxcbiAgICAgIHdpZHRoOiBhdmF0YXJTaXplXG4gICAgfVxuICB9O1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFFZSxTQUFTQSxpQkFBaUJBLENBQUFDLElBQUEsRUFBeUQ7RUFBQSxJQUF0REMsa0JBQWtCLEdBQUFELElBQUEsQ0FBbEJDLGtCQUFrQjtJQUFFQyxVQUFVLEdBQUFGLElBQUEsQ0FBVkUsVUFBVTtFQUN4RSxPQUFPO0lBQ0wsMEJBQTBCLEVBQUU7TUFDMUJDLFlBQVksRUFBRUYsa0JBQWtCO01BQ2hDRyxNQUFNLEVBQUVGLFVBQVU7TUFDbEJHLEtBQUssRUFBRUg7SUFDVDtFQUNGLENBQUM7QUFDSCJ9